import React from 'react';
import {currentResource, labels} from '../../../util/utils';
import utilityfunctions from '../../../util/utilityfunctions';
import CommonAdminTable from '../Common/CommonAdminTable';
import useDetailsSelector from '../Common/Hooks/GetDetailsHook';

function ClientsTable() {
	const clientsInfo = useDetailsSelector('clients');

	const clientsTableConfig = {
		columns: [
			{
				label: labels.nameLabel,
				sortable: true,
				propName: 'name',
				width: '50%'
			},
			{
				label: labels.source,
				sortable: true,
				propName: 'source',
				width: '50%'
			}
		],
		tableClassName: 'tabs-proj-table clients-table',
		items: clientsInfo,
		sortConfig: {
			sortBy: 'name',
			sortIsAscending: true
		}
	};
	return (
		<section>
			<CommonAdminTable config={clientsTableConfig} />
		</section>
	);
}

export default ClientsTable;
